import { AnimatedContainer, AnimatedSection } from '@components/animated'
import CollapsibleAlert from '@components/collapsibleAlert/CollapsibleAlert'
import { useTranslation } from 'react-i18next'
import { ContractList, RentModel } from 'types/api'

import { ContractWidget } from './ContractWidget'
import { RenewalCard } from './RenewalCard'
import { UnpaidRentWidget } from './RentWidget'

interface ContractDashboardProps {
  rents: RentModel[]
  contract?: ContractList
  offer?: ContractList['offer']
}

const ContractDashboard = ({ contract, rents }: ContractDashboardProps) => {
  const { t } = useTranslation('contract')
  return (
    <AnimatedContainer staggerDelay={0.1}>
      <div className="space-y-7">
        <AnimatedSection>
          <div className="space-y-4">
            <RenewalCard contract={contract} />
            <ContractWidget contract={contract} />
          </div>
        </AnimatedSection>

        <AnimatedSection>
          <div>
            <h2 className="mb-5 mt-0 font-display text-xl font-bold tracking-tight text-ink">
              {t('rent_table.payment_title')}
            </h2>
            <div className="space-y-4">
              <CollapsibleAlert
                type="info"
                label={t('rent_table.alert.title')}
                description={
                  <div className="flex flex-col gap-1">
                    <span>1. {t('rent_table.alert.firstStep')}</span>
                    <span>2. {t('rent_table.alert.secondStep')}</span>
                    <span>3. {t('rent_table.alert.thirdStep')}</span>
                  </div>
                }
                isExpanded
              />
              <UnpaidRentWidget rents={rents} />
            </div>
          </div>
        </AnimatedSection>
      </div>
    </AnimatedContainer>
  )
}

export default ContractDashboard
